<template>
    <ui-modal :title="title" :close="close">
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
            </div>
        </template>
        <p
            class="text-sm mt-1 leading-5 text-gray-500"
            v-for="(paragraph, index) in paragraphs"
            :key="index"
            v-text="paragraph"
        ></p>
        <template #footer-primary>
            <ui-button-new danger class="w-full" :loading="form.busy" @click="form.submit()" v-text="button"></ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
export default {
    props: {
        handle: Function,
        close: Function,
        title: {
            type: String,
            default: 'Delete confirmation'
        },
        paragraphs: {
            type: Array,
            default: () => [
                'This action is irreversible. Are you sure you want to proceed?',
            ],
        },
        button: {
            type: String,
            default: 'Yes, delete'
        },
    },
    data () {
        return {
            form: new Form({}, async (form) => {
                await this.handle(form)
                this.close()
            })
        }
    },
}
</script>
